import { useMutation, useQueryClient } from "@tanstack/react-query";

import { OrderSet } from "@models/OrderSet";
import client from "@services/api";

import { useOptionalCurrentOrderSet } from "../../CurrentOrderSetContext";
import { useOptionalOrderSetId } from "../../useOrderSetId";
import { orderSetsKeyFactory } from "../orderSetQueries";

export default function useDeleteOrderSetMutation(id?: string) {
  const queryClient = useQueryClient();
  const orderSetId = useOptionalOrderSetId();
  const orderSetCtx = useOptionalCurrentOrderSet();
  return useMutation({
    mutationFn: () => client.delete(`/order-sets/${orderSetId ?? id}`),
    onSuccess: async ({ id }) => {
      // get find deleted order set
      const deletedOrderSet = queryClient.getQueryData<OrderSet>(
        orderSetsKeyFactory.detail(id).queryKey
      )!;

      await queryClient.invalidateQueries({
        queryKey: orderSetsKeyFactory.paginated._def,
      });

      orderSetCtx?.onOrderSetDelete(deletedOrderSet);
    },
  });
}
